import * as React from 'react'
import { ReactElement } from 'react'
import { FormikSubFieldProps } from './FormikField'
import { InputProps } from '@fluentui/react-input'
import FormikFormattableNumberInputField from './FormikFormattableNumberInputField'

export type FormikDistanceFieldProps<Values> = FormikSubFieldProps<InputProps, Values> & {
    decimals?: number
    unit?: string
}

/**
 * A distance input: like the amount input the user types a comma (12,5) while the form keeps the American notation the
 * backend expects (12.50). Distances are stored with decimals, so part of a kilometre can be registered as well.
 */
export default function FormikDistanceField<Values>({ unit, decimals, ...props }: FormikDistanceFieldProps<Values>): ReactElement {
    return (
        <FormikFormattableNumberInputField<Values>
            {...props}
            decimals={decimals ?? 2}
            componentProps={{
                contentAfter: unit ?? 'km',
                ...props.componentProps,
            }}
        />
    )
}
